import * as actionTypes from "../actionTypes";
import createReducer from "../lib/createReducer";

const defaultState = {};

function JOINPATHS_SET(state, action) {
	const { joinpaths } = action;
	if (joinpaths.length === 0) {
		return state;
	}

	const nextState = { ...state };
	for (let i = 0; i < joinpaths.length; i++) {
		nextState[joinpaths[i].__id] = joinpaths[i];
	}

	return nextState;
}

const handlers = {};
handlers[actionTypes.JOINPATHS_SET] = JOINPATHS_SET;
export default createReducer(defaultState, handlers);
